import { FC } from 'react';

import { UNIVERSITY_DEFAULT_TEMPLATE_CERTIFICATE_IMAGE } from '@common/constant/iconConstant';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import NextLink from 'src/components/atoms/link';

import { CertificateContainer, ImageWrapperCertificate } from './style';

import Image from '@components/atoms/image';
import { Button } from '@components/molecules/academicLandingPage/courseCard/style';
import { getAssetUrl } from '@helpers/utils';

type CertificateSectionProps = {
  templateCertificateImageUrl?: string;
};

export const CertificateSection: FC<CertificateSectionProps> = ({ templateCertificateImageUrl }) => {
  const { t } = useTranslation();

  return (
    <CertificateContainer>
      <ImageWrapperCertificate>
        <Image
          src={templateCertificateImageUrl ?? UNIVERSITY_DEFAULT_TEMPLATE_CERTIFICATE_IMAGE}
          alt="Certificate"
          errorImage={`${getAssetUrl('thumbnail-course-card.jpg')}`}
        />
      </ImageWrapperCertificate>
      <Box
        padding={{ xs: 0, sm: '24px 0px', md: '48px 0px' }}
        display="flex"
        flexDirection="column"
        gap={{ xs: '32px', md: '40px' }}
      >
        <Box>
          <Typography
            textAlign={{ xs: 'center', sm: 'left' }}
            fontSize={{ xs: '22px', sm: '24x' }}
            lineHeight="24px"
            fontWeight={700}
            color="#00000099"
          >
            {t('academic_landing_page.certificate_section.heading')}
          </Typography>
          <Typography
            fontSize={{ xs: '24px', sm: '30px' }}
            lineHeight={{ xs: '24px', sm: '34px' }}
            fontWeight={700}
            color="#000000de"
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            {t('academic_landing_page.certificate_section.title')}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <NextLink
            href="https://certificate.skilllane.com/check"
            target="_blank"
            width={{ xs: '100%', sm: 'min-content' }}
            minWidth="150px"
          >
            <Button
              sx={{
                color: '#00532A',
                borderColor: '#00532A',
              }}
            >
              {t('academic_landing_page.certificate_section.button')}
            </Button>
          </NextLink>
        </Box>
      </Box>
    </CertificateContainer>
  );
};
